import roundToTwo from '@spa/lib/roundToTwo';

const CENT_AMOUNT: number = 0.05;
const PERCENTAGE: number = 0.1;

export const calculateAbsoluteDiscount = (bigger: number, smaller: number): number =>
  roundToTwo(bigger - smaller);

export const calculatePercentageDiscount = (bigger: number, smaller: number): number =>
  roundToTwo(calculateAbsoluteDiscount(bigger, smaller) / bigger);

const isSufficientlyDifferentPrice = (
  referencePrice: number | undefined,
  price: number | undefined
): boolean =>
  typeof price !== 'undefined' &&
  typeof referencePrice !== 'undefined' &&
  CENT_AMOUNT <= calculateAbsoluteDiscount(price, referencePrice) &&
  PERCENTAGE <= calculatePercentageDiscount(price, referencePrice);

export default isSufficientlyDifferentPrice;
